import { RichText } from 'components/Text/RichText';
import { CmsApiRichTextBlockData } from 'modules/cms/api/types/blocks/CmsApiRichTextBlock';

type Props = {
  data: CmsApiRichTextBlockData;
  fullWidthLayout?: boolean;
};

export function CmsAmpRichTextBlock({
  data: { html },
  fullWidthLayout,
}: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      textAlignCenter={fullWidthLayout}
    />
  );
}
